import { AxiosRequestConfig } from 'axios';

import { HttpClient } from 'helpers/http';

import { PaginationParams } from 'types/common';
import { PaginatedUsers, CreateUser, NewsletterUser } from 'types/services/newsletterUsers';

export class NewsletterUsersService {
  constructor(private client: HttpClient) {}

  API = {
    list: '/api/newsletter-users',
    create: '/api/newsletter-users', // ✅ FIX: Removed `/create`
  };

  list = ({ page, perPage }: PaginationParams) => {
    let url = `${this.API.list}?page=${page}&perPage=${perPage}`;
    return this.client.get<PaginatedUsers>(url);
  };

  create = (user: CreateUser) => {
    console.log('📤 Sending user data to API:', user); // ✅ Log request before sending
    return this.client.post<NewsletterUser>(this.API.create, user);
  };
}
